import { render, staticRenderFns } from "./GridProfissional.vue?vue&type=template&id=6ec5093c"
import script from "./GridProfissional.vue?vue&type=script&lang=js"
export * from "./GridProfissional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports